import React from 'react';
import type { ReactNode } from 'react';
import { motion, useReducedMotion } from 'framer-motion';
interface RevealProps {
  children: ReactNode;
  className?: string;
  delay?: number;
}
export function Reveal({
  children,
  className,
  delay = 0
}: RevealProps) {
  const reduce = useReducedMotion();
  return <motion.div className={className} initial={reduce ? false : {
    opacity: 0,
    y: 16
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.28,
    ease: [0.23, 1, 0.32, 1],
    delay
  }} data-id="element-333" data-mp="ti179ss8dxd4">
      {children}
    </motion.div>;
}